var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticClass:"FullScreenLoading"},[_c('div',{staticClass:"text-xs-center"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"white","size":"40"}}),_c('div',{staticClass:"white--text title mt-4"},[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }